import {
  LABEL_ADD_SUCCESS,
  LABEL_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
import { createReducer } from 'redux-create-reducer'
const initialState: Array<any> = []

export type LabelState = typeof initialState
export const labelReducer = createReducer<LabelState, any>(initialState, {
  [LABEL_ADD_SUCCESS](state, { labels }) {
    return [...state, ...labels]
  },
  [LABEL_UPDATE_SUCCESS](state, { label }) {
    return state.map(l => (l.id === label.id ? { ...l, ...label } : l))
  },
})
